import "./LoginPage.css";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import logo from "@safecv/assets/Images/image4.png";
import bgimage from "@safecv/assets/Images/BG-Image.png";
import AuthenticationService from "./AuthenticationService";
import { getNotificationsSSO } from "@safecv/actions/postActions";

import {
  USER_NAME_SESSION_ATTRIBUTE_NAME,
  TOKEN_SESSION_ATTRIBUTE_NAME,
  ROLE_SESSION_ATTRIBUTE_NAME,
  PROFILE_PREFERENCE,
  REVIEWER_NAME_SESSION_ATTRIBUTE_NAME,
  IS_CC_USER,
} from "@safecv/shared/appConstant";
import { css } from "@emotion/core";
import toast from "@safecv/shared/toast";
import API_CONFIG from "@safecv/src/api-config";
import FadeLoader from "react-spinners/FadeLoader";

import awsconfig from "./../../aws-exports";
import { Auth, Hub } from "aws-amplify";

if (API_CONFIG.FEATURE_REVIEWER_SSO_ENABLED) Auth.configure(awsconfig);

const override = css`
  display: block;
  margin: 0 auto;
  position: absolute;
  margin-left: 15%;
  z-index: 1000;
  margin-right: 50%;
  top: 40%;
  width: 100vw;
`;

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      loading: false,
      hasLoginFailed: false,
      authState: "loading",
      authData: null,
      customState: null,
    };
  }

  componentDidMount() {
    //remove this code after testing
    window.document.__defineGetter__("referrer", function () {
      return "http://communitycore.com";
    });

    AuthenticationService.isCCUser(
      this.props.history.location.state?.sharedRoute
    ).then(([isCCUser, reviewer]) => {
      if (isCCUser) {
        AuthenticationService.CCExecuteBasicAuthenticationService(
          API_CONFIG.INTEGRATION_USER_EMAIL,
          API_CONFIG.INTEGRATION_USER_PASSWORD,
          reviewer
        )
          .then(async (response) => {
            localStorage.setItem(IS_CC_USER, true);

            let profile = await AuthenticationService.fetchProfileData(
              response.data.access_token
            );

            profile.data.notifications.forEach((notify) => {
              toast.success(notify, { autoClose: false });
            });

            localStorage.setItem(
              TOKEN_SESSION_ATTRIBUTE_NAME,
              "Bearer " + response.data.access_token
            );

            localStorage.setItem(
              PROFILE_PREFERENCE,
              JSON.stringify(profile.data.preference)
            );

            localStorage.setItem(
              ROLE_SESSION_ATTRIBUTE_NAME,
              profile.data.role
            );

            localStorage.setItem(
              USER_NAME_SESSION_ATTRIBUTE_NAME,
              profile.data.username
            );
            localStorage.setItem(
              REVIEWER_NAME_SESSION_ATTRIBUTE_NAME,
              profile.data.reviewerName
            );
            if (API_CONFIG.FEATURE_REVIEWER_SSO_ENABLED) {
              AuthenticationService.setupAxiosInterceptors(
                "Bearer " + response.data.access_token
              );

              //removing the reviewer name
              let sharedRoute =
                this.props.history.location.state.sharedRoute.split("?");

              this.setState({
                customState: sharedRoute[0],
              });

              this.isLoggedIn();
            } else {
              AuthenticationService.registerSuccessfulLogin(
                response.data.access_token
              );
              if (
                this.props.history.location.state !== undefined &&
                this.props.history.location.state.sharedRoute !== undefined &&
                this.props.history.location.state.sharedRoute !== ""
              ) {
                //removing the reviewer name
                let sharedRoute =
                  this.props.history.location.state.sharedRoute.split("?");

                this.props.history.replace(sharedRoute[0]);
              } else {
                this.props.history.push(`/plans`);
              }
            }
          })
          .catch(() => {
            this.setState({ hasLoginFailed: true });
          });
      } else {
        Hub.listen("auth", ({ payload: { event, data } }) => {
          if (event === "customOAuthState")
            this.setState({ customState: data });
        });

        if (API_CONFIG.FEATURE_REVIEWER_SSO_ENABLED) {
          Auth.currentAuthenticatedUser()
            .then(async (result) => {
              let userAttributes = result.attributes;
              localStorage.setItem(ROLE_SESSION_ATTRIBUTE_NAME, "REVIEWER");
              localStorage.setItem(
                TOKEN_SESSION_ATTRIBUTE_NAME,
                "Bearer " + result.signInUserSession.idToken.jwtToken
              );
              let profile = await AuthenticationService.fetchPreference(
                result.signInUserSession.idToken.jwtToken
              );
              let notificationsSSO =
                await AuthenticationService.fetchNotifications(
                  result.signInUserSession.idToken.jwtToken
                );
              notificationsSSO.data.notifications.forEach((notify) => {
                toast.success(notify, { autoClose: false });
              });

              localStorage.setItem(
                PROFILE_PREFERENCE,
                JSON.stringify(profile.data.preference)
              );

              AuthenticationService.setupAxiosInterceptorsSSO();
              localStorage.setItem(
                USER_NAME_SESSION_ATTRIBUTE_NAME,
                userAttributes.email
              );
              localStorage.setItem(
                REVIEWER_NAME_SESSION_ATTRIBUTE_NAME,
                userAttributes.name
              );
              this.isLoggedIn();
            })
            .catch((e) => {
              console.log(e);
              this.setState({ authState: "signIn" });
            });
        } else {
          this.isLoggedIn();
          this.setState({ authState: "signIn" });
        }
      }
    });
  }

  isLoggedIn() {
    if (AuthenticationService.isUserLoggedIn()) {
      this.setState({ authState: "signedIn" });

      if (this.state.customState) {
        this.props.history.push(this.state.customState);
      } else {
        this.props.history.push(`/plans`);
      }
    } else {
      this.props.socket && this.props.socket.current.close();
      return <Redirect to="/" />;
    }
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  postData(event) {
    event.preventDefault();
    if (API_CONFIG.FEATURE_REVIEWER_SSO_ENABLED) {
      Auth.federatedSignIn({
        provider: "pro-reviewer",
        customState: this.props.history?.location?.state?.sharedRoute,
      });
    } else {
      // if(this.state.username === 'admin' && this.state.password === 'password') {
      //   AuthenticationService.registerSuccessfulLogin(this.state.username, this.state.password)
      //   this.props.history.push('/plans')
      // }

      AuthenticationService.executeBasicAuthenticationService(
        this.state.username,
        this.state.password
      )
        .then(async (response) => {
          let profile = await AuthenticationService.fetchProfileData(
            response.data.access_token
          );

          profile.data.notifications.forEach((notify) => {
            toast.success(notify, { autoClose: false });
          });

          localStorage.setItem(
            PROFILE_PREFERENCE,
            JSON.stringify(profile.data.preference)
          );
          localStorage.setItem(ROLE_SESSION_ATTRIBUTE_NAME, profile.data.role);
          localStorage.setItem(
            USER_NAME_SESSION_ATTRIBUTE_NAME,
            profile.data.username
          );
          localStorage.setItem(
            REVIEWER_NAME_SESSION_ATTRIBUTE_NAME,
            profile.data.reviewerName
          );
          AuthenticationService.registerSuccessfulLogin(
            response.data.access_token
          );
          if (
            this.props.history.location.state !== undefined &&
            this.props.history.location.state.sharedRoute !== undefined &&
            this.props.history.location.state.sharedRoute !== ""
          ) {
            this.props.history.replace(
              this.props.history.location.state.sharedRoute
            );
          } else {
            this.props.history.push(`/plans`);
          }
        })
        .catch(() => {
          this.setState({ hasLoginFailed: true });
        });

      this.setState({
        loading: true,
      });
    }
  }

  loading() {
    if (this.state.loading) {
      return <p className="loading">Loading...</p>;
    } else {
      return null;
    }
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div id="firsthalf" className="col-sm-4">
            {this.state.hasLoginFailed && (
              <div className="alert alert-warning warning alert-dismissible">
                Invalid Credentials
              </div>
            )}
            <div id="center">
              <img className="style" src={logo} alt="logo" />
              <form onSubmit={this.postData.bind(this)}>
                {API_CONFIG.FEATURE_REVIEWER_SSO_ENABLED ? (
                  <>
                    <br />
                    {this.state.authState === "loading" ? (
                      <div className="logging-in">Logging in ...</div>
                    ) : (
                      <button className="LoginButton">Login with SSO</button>
                    )}
                  </>
                ) : (
                  <>
                    <input
                      className="username"
                      name="username"
                      type="text"
                      placeholder="Username"
                      onChange={this.onChange.bind(this)}
                    />
                    <br />
                    <input
                      className="password"
                      name="password"
                      type="password"
                      placeholder="Password"
                      autoComplete="false"
                      onChange={this.onChange.bind(this)}
                    />
                    <br />
                    <button className="LoginButton">Login</button>
                  </>
                )}
              </form>
            </div>
          </div>
          <div id="secondhalf" className="col-sm-8">
            <div className="banner">
              <img
                className="bgimagestyle img-fluid"
                src={bgimage}
                alt="Responsive Banner"
              />
              <h1 className="textHeading">
                Transforming Community Development
              </h1>
              <p className="textPara">
                With cost-effective and transformative building, infrastructure
                and maintenance solutions.
              </p>
            </div>
          </div>
        </div>
        <FadeLoader
          css={override}
          height={15}
          width={5}
          radius={2}
          margin={2}
          color={"#4183C5"}
          loading={this.state.authState === "loading"}
        />
      </div>
    );
  }
}

export default LoginPage;
